import React from 'react';
import Helmet from 'react-helmet';

import { useLocation } from 'ha/helpers/router';
import { useIntl } from 'ha/i18n';
import { useConfig } from 'ha/helpers/config';

export const Meta: React.FC = () => {
  const { T, urlResolver, lang } = useIntl();
  const location = useLocation();
  const { cdnDomain } = useConfig();

  return (
    <Helmet defaultTitle="HousingAnywhere: Mid to Long-Term Rentals in 400+ cities.">
      <html lang={lang} />
      <meta name="description" content={T('meta_description')} />
      <meta property="og:description" content={T('meta_description')} />
      <meta property="og:type" content="housinganywhere:listing" />
      <meta property="og:site_name" content="HousingAnywhere" />
      <meta
        property="og:url"
        content={urlResolver.absolutizePath(location.pathname, {
          skipAddLanguage: true,
        })}
      />
      <meta property="og:title" content="HousingAnywhere" />
      <meta
        property="og:image"
        content={`${cdnDomain}/img/logo-1200x630.png`}
      />
      {(location.pathname === '/my' || location.pathname.includes('/my/')) && (
        <meta name="robots" content="noindex" />
      )}
    </Helmet>
  );
};

export default Meta;
